import React from 'react'
import { Table, Button, Modal, Tooltip, message, Icon } from 'antd'
import FormattedDate from '../../components/FormattedDate'

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

class ItemListTable extends React.Component {
  constructor(props) {
    super(props)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleCopyUrl = this.handleCopyUrl.bind(this)
    this.handleFolderClick = this.handleFolderClick.bind(this)
  }

  handleFolderClick(record) {
    if (!record || !record.name) return
    const { onFolderClick } = this.props
    if (onFolderClick) {
      onFolderClick(record.name)
    }
  }

  handleDelete(record) {
    if (!record || !record.name) {
      message.error('Invalid item')
      return
    }
    const { onDelete } = this.props
    const type = record.isFolder ? 'Folder' : 'File'
    Modal.confirm({
      title: `Delete ${type}`,
      content: record.isFolder 
        ? `Are you sure you want to delete folder "${record.name}"? Folder must be empty.`
        : `Are you sure you want to delete "${record.name}"?`,
      okType: 'danger',
      onOk() {
        onDelete(record)
      },
    })
  }

  handleCopyUrl(url, label = 'URL') {
    navigator.clipboard.writeText(url).then(() => {
      message.success(`${label} copied to clipboard`)
    }).catch(() => {
      message.error('Failed to copy URL')
    })
  }

  render() {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (name, record) => {
          if (!record) return name || '-'
          return (
            <span>
              <Icon 
                type={record.isFolder ? 'folder' : 'file'} 
                style={{ marginRight: 8, color: record.isFolder ? '#faad14' : '#1890ff' }} 
              />
              {record.isFolder ? (
                <a 
                  onClick={() => this.handleFolderClick(record)}
                  style={{ cursor: 'pointer' }}
                >
                  {name}
                </a>
              ) : (
                <Tooltip title={record.url}>
                  <a href={record.url} target='_blank' rel='noopener noreferrer'>
                    {name}
                  </a>
                </Tooltip>
              )}
            </span>
          )
        },
      },
      {
        title: 'Size',
        dataIndex: 'size',
        key: 'size',
        width: 120,
        render: (size, record) => (record && record.isFolder) ? '-' : formatBytes(size || 0),
      },
      {
        title: 'Last Modified',
        dataIndex: 'lastModified',
        key: 'lastModified',
        width: 180,
        render: text => <FormattedDate text={text} />,
      },
      {
        title: 'Alias URL',
        dataIndex: 'aliasUrl',
        key: 'aliasUrl',
        width: 120,
        render: (aliasUrl, record) => (record && !record.isFolder && aliasUrl) ? (
          <Tooltip title={aliasUrl}>
            <Button
              type='link'
              icon='copy'
              size='small'
              onClick={() => this.handleCopyUrl(aliasUrl, 'Alias URL')}
            >
              Copy
            </Button>
          </Tooltip>
        ) : '-',
      },
      {
        title: 'Action',
        key: 'action',
        width: 180,
        render: (text, record) => {
          if (!record) return null
          return (
            <span>
              {!record.isFolder && (
                <>
                  <Tooltip title='Copy URL'>
                    <Button
                      type='link'
                      icon='copy'
                      size='small'
                      onClick={() => this.handleCopyUrl(record.url)}
                    />
                  </Tooltip>
                  <Tooltip title='Open in new tab'>
                    <Button
                      type='link'
                      icon='eye'
                      size='small'
                      href={record.url}
                      target='_blank'
                    />
                  </Tooltip>
                </>
              )}
              <Tooltip title='Delete'>
                <Button
                  type='link'
                  icon='delete'
                  size='small'
                  style={{ color: '#ff4d4f' }}
                  onClick={() => this.handleDelete(record)}
                  loading={this.props.isDeleteItemLoading}
                />
              </Tooltip>
            </span>
          )
        },
      },
    ]
    return (
      <Table
        rowKey={record => record.key || record.name}
        columns={columns}
        size='small'
        scroll={{ x: 800 }}
        {...this.props}
      />
    )
  }
}

export default ItemListTable

